module.exports = __webpack_public_path__ + "static/media/cancerImage3@2x.22ee4dca.png";